export default "__VITE_ASSET__DdzeHdKy__"